import Enumeration from 'Lib/utilities/Enumeration';

const Components = new Enumeration([
    { id: 1, name: 'Administration' },
    { id: 2, name: 'Accounting' },
    { id: 3, name: 'Leasing' },
    { id: 4, name: 'Properties' },
    { id: 5, name: 'Maintenance' },
    { id: 6, name: 'Portfolios' },
    { id: 7, name: 'Contacts' },
    { id: 8, name: 'Reports' },
    { id: 9, name: 'Notes' },
    { id: 10, name: 'Files' },
    { id: 11, name: 'Alerts' },
    { id: 12, name: 'Screening' },
    { id: 13, name: 'Notifications' },
    { id: 14, name: 'Portfolio Groups' }
]);

export default Components;